import {applyFirstSession, clearFirstSession, isFirstSession} from '@infra/domain/model/Session/SessionRepository';

const ApplyFirstSession = () => (): void => applyFirstSession();

const ClearFirstSession = () => (): void => clearFirstSession();

const IsFirstSession = () => (): boolean => isFirstSession();

export {ApplyFirstSession, ClearFirstSession, IsFirstSession};
